<template>
  <el-dialog
    title="编辑学员信息"
    :visible.sync="memberDialogInfo.show"
    :close-on-click-modal="false"
    @close="handleClose"
    destroy-on-close
    width="600px"
  >
    <el-form
      :model="memberInfo"
      ref="ruleForm"
      :rules="rules"
      label-width="100px"
      class="form"
      size="small"
    >
      <el-form-item label="手机号码：" prop="userMobile">
        <el-input
          placeholder="请输入手机号码"
          v-model="memberInfo.userMobile"
          @input="(val) => phoneChange(val)"
        />
      </el-form-item>
      <el-form-item label="出生年月：" prop="userBirthday">
        <el-date-picker
          v-model="memberInfo.userBirthday"
          type="month"
          format="yyyy-MM"
          value-format="yyyy-MM"
          placeholder="选择出生年月"
        />
      </el-form-item>
      <el-form-item label="工作单位：" prop="deptName">
        <el-input
          placeholder="请输入工作单位"
          v-model="memberInfo.deptName"
          maxlength="64"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="单位及职务：" prop="unitPosition">
        <el-input
          placeholder="请输入单位及职务"
          v-model="memberInfo.unitPosition"
          maxlength="255"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import { limitPhone } from "@/utils/rules/limitInputs.js";
import { validMobile } from "@/utils/rules/validators.js";
import butn from "@/components/button/index";
import { updateStudent } from "@/api/enrollOffline.js";

export default {
  components: { butn },
  props: {
    memberDialogInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          member: {},
        };
      },
    },
  },
  data() {
    return {
      memberInfo: {
        uuid: "",
        userMobile: null,
        userBirthday: null,
        deptName: "",
        unitPosition: "",
      },
      rules: {
        userMobile: [
          { required: true, validator: validMobile, trigger: "blur" },
        ],
        userBirthday: [{ required: true, message: "请选择出生年月" }],
        deptName: [{ required: true, message: "请输入工作单位" }],
        unitPosition: [{ required: true, message: "请输入单位及职务" }],
      },
    };
  },
  mounted() {
    const {
      uuid,
      phone: userMobile,
      userBirthday,
      deptName,
      unitPosition,
    } = this.memberDialogInfo.member;
    this.memberInfo = {
      uuid,
      userMobile,
      userBirthday,
      deptName,
      unitPosition,
    };
  },
  methods: {
    handleClose(flag = false) {
      this.$emit("closeEditMember", flag);
    },
    phoneChange(val) {
      this.memberInfo.userMobile = limitPhone(val);
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          updateStudent(this.memberInfo).then(({ code, msg }) => {
            if (code !== 0) return;
            this.$message.success(msg);
            this.handleClose(true);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}
</style>